"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (function (v) { return v; });
//# sourceMappingURL=identity.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/util/lib/identity.js
// module id = 1108
// module chunks = 37